<template>
    <div ref="pageBox">
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcCode" :placeholder="$t('base.PleaseSelect')" :clearable="true" filterable @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.spareSort')">
                    <el-select v-model="spcId" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="searchTable">
                        <el-option v-for="classify in classifyList" :key="classify.spcId" :label="classify.spcName" :value="classify.spcId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.unit')">
                    <el-select v-model="unit" :placeholder="$t('base.PleaseSelect')" clearable filterable @change="searchTable">
                        <el-option v-for="unit in unitList" :key="unit.unitId" :label="unit.unitDesc" :value="unit.unitCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.sort')">
                    <el-select v-model="spLevel" :placeholder="$t('base.PleaseSelect')" clearable @change="searchTable">
                        <el-option label="A" value="A"></el-option>
                        <el-option label="B" value="B"></el-option>
                        <el-option label="C" value="C"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Account.spareName')">
                    <el-input v-model.trim="spName" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareCode')">
                    <el-input v-model.trim="spCode" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareBrand')">
                    <el-input v-model.trim="spBrand" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.spareModel')">
                    <el-input v-model.trim="spModel" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.remark')">
                    <el-input v-model.trim="remark" :placeholder="$t('base.PleaseEnter')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="searchTable()">{{ $t('base.search') }}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('demo.menu.SpareAccount')" ref="LabelContent">
            <!-- <div slot="btns">
                <span v-for="acc in access" :key="acc">
                    <el-button size="small" type="success" @click=";(ifAddText = '0'), updatePartInfo()" v-if="acc == 'SPAREPART001'" style="margin-right:10px">{{ $t('base.add') }} </el-button>
                </span>
                <el-button size="small" type="success" @click="sparePartInfoTemplate()">{{ $t('base.Mould') }}</el-button>
                <el-button size="small" type="success" @click="sparePartInfoImport()">{{ $t('base.Import') }}</el-button>
                <el-button size="small" type="success" @click="exportSparePartInfo()">{{ $t('base.export') }}</el-button>
                <el-button size="small" type="success" @click=";(record = true), updateToolingRecord()">领用</el-button>
                <el-button size="small" type="warning" @click=";(record = false), updateToolingRecord()">归还</el-button>
            </div> -->
        </LabelContent>
        <div class="tableBox">
            <!--            <el-table stripe ref="multipleTable" :data="tableData" class="center" :cell-style="rowClass"-->
            <el-table stripe ref="multipleTable" :data="tableData" class="center" @selection-change="handleSelectionChange" @sort-change="sortChange" border>
                <el-table-column prop="spCode" :label="$t('Account.spareCode')" width="90" />
                <el-table-column prop="spName" :label="$t('Account.spareName')" width="100" />
                <el-table-column prop="spBrand" :label="$t('Account.spareBrand')" width="90" />
                <el-table-column prop="spModel" :label="$t('Account.spareModel')" width="90" show-overflow-tooltip />
                <el-table-column prop="fcName" :label="$t('Shift.factory')" width="180" />
                <el-table-column prop="spLevel" :label="$t('Account.sort')" />
                <el-table-column prop="spcName" :label="$t('Account.spareSortName')" width="130" />
                <el-table-column prop="spSafeStock" :label="$t('Account.safetyStock')" width="90" />
                <el-table-column prop="spSurplusStock" sortable :label="$t('Account.currentStock')" width="120" />
                <el-table-column prop="spMaxStock" sortable :label="$t('Account.stockCeil')" width="100" />
                <el-table-column prop="partStatus" :label="$t('Account.currentState')" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.partStatus.code != 'd_bepending'">{{ scope.row.partStatus.desc }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('Account.stockState')" width="120">
                    <template slot-scope="scope">
                        <el-progress v-if="scope.row.partStatus.code == 'a_insufficient'" :stroke-width="10" :percentage="scope.row.invStatus" :color="color" />
                        <el-progress v-else-if="scope.row.partStatus.code == 'b_purchase'" :stroke-width="10" :percentage="scope.row.invStatus" :color="color1" />
                        <el-progress v-else-if="scope.row.partStatus.code == 'c_normal'" :stroke-width="10" :percentage="scope.row.invStatus" :color="color2" />
                    </template>
                </el-table-column>
                <el-table-column prop="unit" :label="$t('Account.unit')" width="80" />
                <el-table-column prop="spPrice" sortable :label="$t('Account.price')" />
                <el-table-column prop="supplierCode" :label="$t('Account.supplierCode')" width="100" />
                <el-table-column prop="supplierName" :label="$t('Account.supplierName')" width="105" />
                <el-table-column prop="remark" :label="$t('Account.remark')" />
                <!-- <el-table-column :label="$t('base.operation')" fixed="right" width="90">
                    <template slot-scope="scope">
                        <span v-for="acc in access" :key="acc">
                            <i class="editBtn iconfont u-youjianbianji" @click=";(ifAddText = '1'), updatePartInfo(scope.row)" v-if="acc == 'SPAREPART002'" />
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" v-if="acc == 'SPAREPART003'" />
                        </span>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="$t('Account.spareImport')" :visible.sync="sparePartInfoImportShow">
            <el-upload class="upload-demo" drag :headers="{ 'X-Auth-Token': token }" :action="sparePartURL" :on-success="itemSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                    {{ $t('msg.Drag') }} <em>{{ $t('msg.Upload') }}</em>
                </div>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
import jQuery from 'jquery'

export default {
    name: 'factorySparePart',
    data() {
        return {
            searchParams: {
                param: {},
                pageSize: 10,
                page: 1,
                pageCount: 0
            },
            color: 'rgb(175 44 44)',
            color1: 'rgb(227 195 52)',
            color2: 'rgb(69 227 52)',
            fcCode: '',
            unit: '',
            spcId: '',
            spLevel: '',
            spName: '',
            spCode: '',
            spBrand: '',
            spModel: '',
            remark: '',
            tableData: [],
            ifAddText: '',
            classifyList: [],
            factoryList: [],
            unitList: [],
            userInfo: {},
            role: {},
            ischeck: true,
            isclear: false,
            access: [],
            URL: '',
            token: '',
            sparePartInfoImportShow: false,
            sparePartURL: ''
        }
    },
    mounted() {
        this.URL = 'https://tpm.joysonsafety.com.cn/api/upload/files'
        this.token = sessionStorage.getItem('authToken')
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        init() {
            // this.userInfo = sessionStorage.getItem("userInfo")
            this.access = JSON.parse(sessionStorage.getItem('auths'))
            this.userInfo = this.$store.state.userInfo
            var role = this.userInfo.roles
            // for (var i = 0; i < role.length; i++) {
            //     //所有工厂数据
            //     if (role[i].factoryId == 0) {
            //         this.ischeck = false
            //         this.role = role[i]
            //         this.isclear = true
            //         break
            //     } else {
            //         if (this.userInfo.factoryId == role[i].factoryId) {
            //             this.role = role[i]
            //         }
            //     }
            // }
            this.getAllFactory()
            this.getUnitList()
        },
        rowClass(row, index) {
            if (row.row.partStatus.code == 'd_bepending') {
                return {
                    'background-color': '#fff'
                }
            }
            if (row.row.spSurplusStock < row.row.spSafeStock) {
                return {
                    'background-color': 'rgb(232 134 134)',
                    color: '#fff'
                }
            } else if (row.row.spSurplusStock >= row.row.spSafeStock) {
                return {
                    'background-color': '#fff'
                }
            }
        },
        updatePartInfo(row) {
            this.$router.push({
                name: 'addSparePartInfo',
                params: {
                    spareLingInfo: row,
                    spareIfAddText: this.ifAddText
                }
            })
        },
        deleteRow(row) {
            this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                confirmButtonText: this.$t('base.delete'),
                cancelButtonText: this.$t('base.cancel'),
                type: 'warning'
            })
                .then(() => {
                    this.$http
                        .request({
                            method: 'POST',
                            headers: { 'content-type': 'application/json' },
                            params: { spiId: row.spiId },
                            url: this.$api.deleteSparePartInfo
                        })
                        .then(response => {
                            this.searchTable()
                            // this.$message.success(response.message);
                        })
                        .catch(err => {
                            this.searchTable()
                            // this.$message.error(err);
                        })
                })
                .catch(() => {
                    this.searchTable()
                    this.$message({
                        type: 'info',
                        message: this.$t('msg.cancel')
                    })
                })
        },
        getPartClassifyList() {
            let params = {}
            this.classifyList = []
            if (this.fcCode != undefined && this.fcCode != '') {
                params['fcCode'] = this.fcCode
            } else {
                return
            }
            let options = {
                method: 'get',
                url: this.$api.partClassifyList,
                params: params
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.classifyList = response.data
                }
            })
        },
        getAllFactory() {
            let options = {
                method: 'get',
                url: this.$api.getAllFactory
            }
            this.$http.request(options).then(response => {
                this.factoryList = []
                // var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                // var aa = response.data
                // if (this.ischeck) {
                //     for (var i = 0; i < aa.length; i++) {
                //         for (let j = 0; j < userInfo.roles.length; j++) {
                //             if (aa[i].factoryId == userInfo.roles[j].factoryId) {
                //                 this.factoryList.push(aa[i])
                //                 this.fcCode = this.userInfo.fcCode
                //             }
                //         }
                //     }
                // } else {
                //     this.factoryList = response.data
                // }
                this.factoryList = response.data
                this.searchTable()
                this.getPartClassifyList()
            })
        },
        getUnitList() {
            let options = {
                method: 'get',
                url: this.$api.unitList
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.unitList = response.data
                }
            })
        },
        //分页
        paginationChange(val) {
            this.searchParams.pageSize = val
            this.searchTable()
        },
        paginationCurrentChange(val) {
            this.searchParams.page = val
            this.searchTable()
        },
        //多选框选择 返回当前已选行数据(Array)
        handleSelectionChange(val) {
            console.log(val)
        },
        //从后台获取数据,重新排序
        sortChange(val) {
            // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
            console.log(val)
        },
        fcChange() {
            this.spcId = ''
            this.searchTable()
            this.getPartClassifyList()
        },
        sparePartInfoTemplate() {
            if (this.fcCode == undefined || this.fcCode == '') {
                this.$message.error(this.$t('mechanism.selectFc'))
                return
            }
            var inputs = ''
            var lang = this.$t('lang')
            inputs += '<input type="hidden" name="token" value="' + this.token + '" />'
            inputs += '<input type="hidden" name="language" value="' + lang + '" />'
            if (this.fcCode != '' && this.fcCode != undefined) {
                inputs += '<input type="hidden" name="fcCode" value="' + this.fcCode + '" />'
            }
            var url = this.$api.sparePartInfoTemplate

            jQuery('<form action="' + url + '" method=POST>' + inputs + '</form>')
                .appendTo('body')
                .submit()
                .remove()
        },
        sparePartInfoImport() {
            if (this.fcCode == undefined || this.fcCode == '') {
                this.$message.error(this.$t('mechanism.selectFc'))
                return
            }
            if (this.fcCode != '' && this.fcCode != undefined) {
                this.sparePartInfoImportShow = true
                this.sparePartURL = this.$api.sparePartInfoImport + '?fcCode=' + this.fcCode + '&language=' + this.$t('lang')
            }
        },
        itemSuccess(resp) {
            if (resp.status == 101) {
                alert(resp.message)
            } else if (resp.status == 100) {
                this.$message.success(this.$t('base.ImportSucceeded'))
                this.sparePartInfoImportShow = false
                this.searchTable()
            }
        },
        async exportSparePartInfo() {
            let queryParams = {}
            queryParams['language'] = this.$t('lang')
            if (this.fcCode != undefined && this.fcCode != '') {
                queryParams['fcCode'] = this.fcCode
            }
            if (this.unit != undefined && this.unit != '') {
                queryParams['unit'] = this.unit
            }
            if (this.spcId != undefined && this.spcId != '') {
                queryParams['spcId'] = this.spcId
            }
            if (this.spLevel != undefined && this.spLevel != '') {
                queryParams['spLevel'] = this.spLevel
            }
            if (this.spName != undefined && this.spName != '') {
                queryParams['spName'] = this.spName
            }
            if (this.spCode != undefined && this.spCode != '') {
                queryParams['spCode'] = this.spCode
            }
            if (this.spBrand != undefined && this.spBrand != '') {
                queryParams['spBrand'] = this.spBrand
            }
            if (this.spModel != undefined && this.spModel != '') {
                queryParams['spModel'] = this.spModel
            }

            let options = {
                method: 'POST',
                params: queryParams,
                url: this.$api.exportSparePartInfo,
                responseType: 'blob',
                headers: {
                    'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                }
            }
            let result = await this.$http.request(options)
            var elink = document.createElement('a')
            elink.download = this.$t('Account.spareInfo') //设置名称
            elink.style.display = 'none'
            var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink) //追加节点
            elink.click()
            document.body.removeChild(elink) //删除节点
        },
        searchTable() {
            let queryParams = {
                pageSize: this.searchParams.pageSize,
                pageNum: this.searchParams.page
            }
            if (this.fcCode != undefined && this.fcCode != '') {
                queryParams['fcCode'] = this.fcCode
            }
            if (this.unit != undefined && this.unit != '') {
                queryParams['unit'] = this.unit
            }
            if (this.spcId != undefined && this.spcId != '') {
                queryParams['spcId'] = this.spcId
            }
            if (this.spLevel != undefined && this.spLevel != '') {
                queryParams['spLevel'] = this.spLevel
            }
            if (this.spName != undefined && this.spName != '') {
                queryParams['spName'] = this.spName
            }
            if (this.spCode != undefined && this.spCode != '') {
                queryParams['spCode'] = this.spCode
            }
            if (this.spBrand != undefined && this.spBrand != '') {
                queryParams['spBrand'] = this.spBrand
            }
            if (this.spModel != undefined && this.spModel != '') {
                queryParams['spModel'] = this.spModel
            }
            if (this.remark != undefined && this.remark != '') {
                queryParams['remark'] = this.remark
            }
            let options = {
                method: 'get',
                url: this.$api.getAllSparePart,
                params: queryParams
            }
            this.$http.request(options).then(response => {
                if (response.status == 100) {
                    this.tableData = response.data.list
                    this.searchParams.pageCount = response.data.total
                }
            })
        }
    }
}
</script>

<style scoped>
.el-progress__text {
    color: red;
}
</style>
